export type {TextInputProps} from './TextInput.interface';
export {TextInput} from "./TextInput";